import { displayGlobalMessage } from '../actions/globalMessage';
import { showHideMeetingRoomAddUsersModal } from '../actions/modal';
import { getMeetingRoomUsers, SEARCH_SELECT_USERS_FORM } from './user';

export const GET_MEETING_ROOMS = 'GET_MEETING_ROOMS';
export const GOT_MEETING_ROOMS_IN_QV = 'GOT_MEETING_ROOMS_IN_QV';
export const CLEAR_MEETING_ROOM_IN_QV = 'CLEAR_MEETING_ROOM_IN_QV';
export const ERROR_GETTING_MEETING_ROOMS_IN_QV = 'ERROR_GETTING_MEETING_ROOMS_IN_QV';

export const UPDATE_MEETING_ROOM_FORM = 'UPDATE_MEETING_ROOMS_FORM';
export const RESET_MEETING_ROOM_FORM = 'RESET_MEETING_ROOMS_FORM';
export const CLICKED_NEW_MEETING_ROOM = 'CLICKED_NEW_MEETING_ROOM';

export const UPDATE_MEETING_ROOM = 'UPDATE_MEETING_ROOM';
export const UPDATED_MEETING_ROOM = 'UPDATED_MEETING_ROOM';
export const CLICKED_UPDATE_MEETING_ROOM = 'CLICKED_UPDATE_MEETING_ROOM';

export const DELETE_MEETING_ROOM = 'DELETE_MEETING_ROOM';
export const DELETED_MEETING_ROOM = 'DELETED_MEETING_ROOM';

export const RESET_MEETING_ROOM = 'RESET_MEETING_ROOM';
export const UPDATE_MEETING_ROOMS_PERMISSION = 'UPDATE_MEETING_ROOMS_PERMISSION';

export const CREATE_MEETING_ROOM = 'CREATE_MEETING_ROOM';

export const GET_MEETING_ROOM_PARTICIPANTS = 'GET_MEETING_ROOM_PARTICIPANTS';
export const GOT_MEETING_ROOM_PARTICIPANTS = 'GOT_MEETING_ROOM_PARTICIPANTS';
export const STOPPED_GETTING_MEETING_ROOMS = 'STOPPED_GETTING_MEETING_ROOMS';

export const CLICKED_JOIN_MEETING_ROOM = 'CLICKED_JOIN_MEETING_ROOM';

export const GET_MEETING_ROOM_DETAILS = 'GET_MEETING_ROOM_DETAILS';
export const GOT_MEETING_ROOM_DETAILS = 'GOT_MEETING_ROOM_DETAILS';
export const ERROR_GETTING_MEETING_ROOM_DETAILS = 'ERROR_GETTING_MEETING_ROOM_DETAILS';
export const UPDATE_FETCHING_MEETING_ROOM = 'UPDATE_FETCHING_MEETING_ROOM';

export const GET_MEETING_ROOM_INVITE_DETAILS = 'GET_MEETING_ROOM_INVITE_DETAILS';
export const GOT_MEETING_ROOM_INVITE_DETAILS = 'GOT_MEETING_ROOM_INVITE_DETAILS';

export const RESET_FETCHING_FLAG = 'RESET_FETCHING_FLAG';

export const RESET_MEETING_ROOM_INVITATION_DIALOG = 'RESET_MEETING_ROOM_INVITATION_DIALOG';

export const UPDATE_MEETING_ROOM_SEARCH = 'UPDATE_MEETING_ROOM_SEARCH';

export const SEND_SMS_INVITATION_MEETING_ROOM = 'SEND_SMS_INVITATION_MEETING_ROOM';
export const SENT_SMS_INVITATION_MEETING_ROOM = 'SENT_SMS_INVITATION_MEETING_ROOM';

export const GET_LAST_TIME_MEETING_ROOM_USED = 'GET_LAST_TIME_MEETING_ROOM_USED';
export const GOT_LAST_TIME_MEETING_ROOM_USED = 'GOT_LAST_TIME_MEETING_ROOM_USED';

export const GET_MEETING_ROOM_RECENT_CALLS = 'GET_MEETING_ROOM_RECENT_CALLS';
export const GOT_MEETING_ROOM_RECENT_CALLS = 'GOT_MEETING_ROOM_RECENT_CALLS';
export const STOPPED_GETTING_RECENT_MEETING_ROOMS = 'STOPPED_GETTING_RECENT_MEETING_ROOMS';

export const ERROR_GETTING_RECENT_MEETING_ROOMS = 'ERROR_GETTING_RECENT_MEETING_ROOMS';
export const DISCONNECT_CALLER = 'DISCONNECT_CALLER';
export const CALLER_DISCONNECTED = 'CALLER_DISCONNECTED';

// Selected participant in meeting room
export const UPDATE_SELECTED_PARTICIPANT_FORM_MR = 'UPDATE_SELECTED_PARTICIPANT_FORM_MR';
// Select meeting room
export const SELECTED_MEETING_ROOM = 'SELECTED_MEETING_ROOM';

// Reset Guest Link
export const GUEST_LINK_UPDATED = 'GUEST_LINK_UPDATED';

// Edit meeting room properties
export const RESET_EDIT_MEETING_ROOM_FORM = 'RESET_EDIT_MEETING_ROOM_FORM';
export const UPDATE_EDIT_MEETING_ROOM_FORM = 'UPDATE_EDIT_MEETING_ROOM_FORM';

// Manage users
export const UPDATE_MEETING_ROOM_MEMBER_SEARCH = 'UPDATE_MEETING_ROOM_MEMBER_SEARCH';
export const UPDATE_MR_SELECTED_USER_FOR_MANAGEMENT = 'UPDATE_MR_SELECTED_USER_FOR_MANAGEMENT';
export const GOT_AVAILABLE_ROLES_FOR_MEETING_ROOM = 'GOT_AVAILABLE_ROLES_FOR_MEETING_ROOM';
export const MR_ADD_USERS_FORM = {
  SELECT_ROLE: 'MR_ADD_USERS_FORM.SELECT_ROLE',
  UNSELECT_ROLE: 'MR_ADD_USERS_FORM.UNSELECT_ROLE',
  UPDATE_MESSAGE: 'MR_ADD_USERS_FORM.UPDATE_MESSAGE',
  CLEAR_FORM: 'MR_ADD_USERS_FORM.CLEAR_FORM',
  ADDING_USERS_TO_MEETING_ROOM: 'MR_ADD_USERS_FORM.ADDING_USERS_TO_MEETING_ROOM',
};
export const SELECT_MEETING_ROOM_ID = 'SELECT_MEETING_ROOM_ID';
export const UPDATE_ROLES_FOR_SELECTED_USER_IN_MR_MANAGE_USERS_PAGE =
  'UPDATE_ROLES_FOR_SELECTED_USER_IN_MR_MANAGE_USERS_PAGE';

// Meeting Room pagination
export const ERROR_GETTING_MEETING_ROOMS_PAGINATION = 'ERROR_GETTING_MEETING_ROOMS_PAGINATION';
export const GOT_MEETING_ROOMS_PAGINATION = 'GOT_MEETING_ROOMS_PAGINATION';
export const RESET_MR_SEARCH_FROM = 'RESET_MR_SEARCH_FROM';
export const UPDATE_MR_SEARCH_FROM = 'UPDATE_MR_SEARCH_FROM';
export const UPDATE_CURRENT_ACTIVE_PAGENO_FOR_MRS_PAGE = 'UPDATE_CURRENT_ACTIVE_PAGENO_FOR_MRS_PAGE';
export const IS_ON_MR_LISTING_PAGE = 'IS_ON_MR_LISTING_PAGE';

import fc from '../businessLogic/fetchInterceptor';

export function selectMeetingRoomId(meetingRoomId, cb) {
  return (dispatch) => {
    return dispatch({ type: SELECT_MEETING_ROOM_ID, data: meetingRoomId });
  };
}
// Select meeting room
export function selectMeetingRoom(meetingRoom) {
  return (dispatch) => {
    dispatch({ type: SELECTED_MEETING_ROOM, data: meetingRoom });
  };
}

export function updateMeetingRoomSearch(searchTerm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_MEETING_ROOM_SEARCH, data: searchTerm });
  };
}

export function updateMeetingRoomsPermission(data) {
  return (dispatch) => {
    dispatch({ type: UPDATE_MEETING_ROOMS_PERMISSION, data });
  };
}

export function getHomePanelMeetingRooms(cb, showSpinner) {
  return (dispatch) => {
    let mandatoryCallback = (actionToDispatch) => {
      return actionToDispatch;
    };
    let errorCallback = (response) => {
      console.error(response);
      dispatch({ type: ERROR_GETTING_MEETING_ROOMS_IN_QV });
    };
    // Show it's fetching
    if (!!showSpinner) {
      dispatch({ type: CLEAR_MEETING_ROOM_IN_QV });
      dispatch({ type: GET_MEETING_ROOMS });
    }

    const apiParams = 'meetingRooms/RecentlyUsedMeetingRooms';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiParams)
      .then((data) => {
        if (cb) cb(data);

        // refetch the all meetings (once again) upon first pubnub subscribe, so that VCM client does not miss out any calls made while subscribing
        return dispatch({ type: GOT_MEETING_ROOMS_IN_QV, data: data });
      })
      .catch((err) => errorCallback());
  };
}

export function clickedJoinMeetingRoom(meetingRoomId) {
  return (dispatch) => {
    dispatch({ type: CLICKED_JOIN_MEETING_ROOM, data: meetingRoomId });
  };
}

export function getLastTimeMeetingRoomUsed(meetingRoomId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_LAST_TIME_MEETING_ROOM_USED });
    fc.get(window.APP.CONFIGURATION.VCCAPI + 'meetingrooms/' + meetingRoomId + '/lastused')
      .then((data) => {
        if (cb) cb(data);
        return dispatch({ type: GOT_LAST_TIME_MEETING_ROOM_USED, data: data });
      })
      .catch((err) => console.error('There was an API error', err.toString()));
  };
}

export function getMeetingRoomDetails(meetingRoomId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_MEETING_ROOM_DETAILS });
    fc.get(window.APP.CONFIGURATION.VCCAPI + 'meetingRooms/' + meetingRoomId)
      .then((data) => {
        let res = dispatch({ type: GOT_MEETING_ROOM_DETAILS, data: data });
        if (cb) cb(data);
        return res;
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        dispatch({ type: ERROR_GETTING_MEETING_ROOM_DETAILS });
      });
  };
}

export function updateFetchingMR(isFetching) {
  return (dispatch) => {
    return dispatch({ type: UPDATE_FETCHING_MEETING_ROOM, data: isFetching });
  };
}

export function getMeetingRoomInviteDetails(meetingRoomId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_MEETING_ROOM_INVITE_DETAILS });
    fc.get(window.APP.CONFIGURATION.VCCAPI + 'meetingrooms/' + meetingRoomId + '/Invite')
      .then((data) => {
        data.meetingRoomId = meetingRoomId;
        if (cb) cb(data.meetingRoomId);
        return dispatch({ type: GOT_MEETING_ROOM_INVITE_DETAILS, data: data });
      })
      .catch((err) => console.error('There was an API error', err.toString()));
  };
}

export function deleteMeetingRoom(meetingRoomForm, cb) {
  return (dispatch) => {
    dispatch({ type: DELETE_MEETING_ROOM });
    fc.delete(window.APP.CONFIGURATION.VCCAPI + 'meetingRooms/' + meetingRoomForm.id)
      .then((data) => {
        let res = dispatch({
          type: DELETED_MEETING_ROOM,
          data: meetingRoomForm,
        });
        var successMessage = APP.LANGUAGE.DeleteMeeting.DeleteMeetingRoomSuccess.replace(
          '##meetingRoomName##',
          meetingRoomForm.name
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) cb(true);
        return res;
      })
      .catch((err) => {
        dispatch({ type: RESET_FETCHING_FLAG }); //RESET THE Meeting ROOM FORM FLAG
        if (cb) cb(false);
        console.error('There was an API error', err.toString());
      });
  };
}
export function createMeetingRoom(meetingRoomFormData, cb) {
  return (dispatch) => {
    dispatch({ type: CREATE_MEETING_ROOM });
    fc.post(window.APP.CONFIGURATION.VCCAPI + 'meetingRooms', {
      body: JSON.stringify(meetingRoomFormData),
    })
      .then((data) => {
        if (cb) cb(true);
        dispatch({ type: RESET_FETCHING_FLAG });
        var successMessage = APP.LANGUAGE.CreateUpdateMeetingRoom.CreateMeetingRoomSuccess.replace(
          '##meetingRoomName##',
          meetingRoomFormData.name
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        dispatch({ type: RESET_FETCHING_FLAG });
        if (cb) cb(false);
        console.error('There was an API error', err.toString());
      });
  };
}

export function resetCreateMeetingRoomForm() {}

export function clickedNewMeetingRoom(meetingRoomId) {
  return (dispatch) => {
    dispatch({ type: CLICKED_NEW_MEETING_ROOM });
  };
}

export function clickedUpdateMeetingRoom(meetingRoomId) {
  return (dispatch) => {
    dispatch({ type: CLICKED_UPDATE_MEETING_ROOM });
  };
}

export function updateMeetingRoom(meetingRoomFormData, cb) {
  console.log('i am in update');
  return (dispatch) => {
    dispatch({ type: UPDATE_MEETING_ROOM });

    fc.put(window.APP.CONFIGURATION.VCCAPI + 'meetingRooms/' + meetingRoomFormData.id, {
      body: JSON.stringify(meetingRoomFormData),
    })
      .then((data) => {
        if (cb) cb();
        var successMessage = APP.LANGUAGE.CreateUpdateMeetingRoom.UpdateMeetingRoomSuccess.replace(
          '##meetingRoomName##',
          meetingRoomFormData.name
        );
        dispatch({ type: UPDATED_MEETING_ROOM, data: meetingRoomFormData }); //dispatching client meetingRoomFormData
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        dispatch({ type: RESET_FETCHING_FLAG });
        console.error('There was an API error', err.toString());
      });
  };
}

export function resetMeetingRoomForm() {
  return (dispatch) => {
    dispatch({ type: RESET_MEETING_ROOM_FORM });
  };
}

// Edit meeting room properties
export function updateEditMeetingRoomProperties(meetingRoomId, meetingRoomForm, cb) {
  return (dispatch) => {
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'meetingRooms/' + meetingRoomId, {
      body: JSON.stringify(meetingRoomForm),
    })
      .then((data) => {
        if (cb) cb(true);
        var successMessage = APP.LANGUAGE.EditMeetingRoomProperties.SuccessfulMessage.replace(
          '##meetingRoomName##',
          meetingRoomForm.name
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      })
      .catch((err, resp) => {
        dispatch({ type: RESET_FETCHING_FLAG });
        console.error('There was an API error', err.toString());
        if (cb) cb(false);
      });
  };
}

export function resetInviteGuest() {
  return (dispatch) => {
    dispatch({ type: RESET_MEETING_ROOM_INVITATION_DIALOG });
  };
}

export function updateMeetingRoomForm(updatedMeetingRoomForm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_MEETING_ROOM_FORM, data: updatedMeetingRoomForm });
  };
}

export function updateSelectedParticipantInMRForm(selectedParticipantForm) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_SELECTED_PARTICIPANT_FORM_MR,
      data: selectedParticipantForm,
    });
  };
}

export function getMeetingRoomParticipants(meetingRoomId, cb) {
  return (dispatch) => {
    dispatch({ type: GET_MEETING_ROOM_PARTICIPANTS });
    fc.get(window.APP.CONFIGURATION.VCCAPI + 'meetingRooms/' + meetingRoomId)
      .then((data) => {
        let res = dispatch({ type: GOT_MEETING_ROOM_PARTICIPANTS, data: data });
        if (cb) cb();
        return res;
      })
      .catch((err) => console.error('There was an API error', err.toString()));
  };
}

export function sendSmsInvitationAsync(smsInfo) {
  // meeting room; number; content
  return (dispatch) => {
    dispatch({ type: SEND_SMS_INVITATION_MEETING_ROOM, data: smsInfo });
    let apiParam = 'meetingRooms/SendSmsInvitation/' + smsInfo.id + '?numbers=' + smsInfo.numbers;
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((res) => {
        console.warn(res);
        if (res.ok) {
          setTimeout(function () {
            let successMessage = APP.LANGUAGE.InviteMeetingRoom.SmsSuccessfulMessage.replace(
              '##meetingName##',
              smsInfo.name
            ).replace('##numbers##', smsInfo.numbers);
            dispatch({ type: SENT_SMS_INVITATION_MEETING_ROOM, data: smsInfo });
            dispatch(
              displayGlobalMessage({
                text: successMessage,
                visible: true,
                messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
                autoHide: true,
              })
            );
          }, 1000); // TODO: remove this later
        } else {
          console.error('get api error from sms sending:', res);
        }
      })
      .catch((err) => console.error('There was an API error', err.toString()));
  };
}

export function disconnectCaller(vidyoCallId, callerName, cb) {
  return (dispatch) => {
    dispatch({ type: DISCONNECT_CALLER, data: vidyoCallId });
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'meetingrooms/' + vidyoCallId + '/disconnectParticipant')
      .then((response) => {
        var successMessage = APP.LANGUAGE.MeetingRoomPersonStatus.DisconnectSuccess.replace(
          '##callerName##',
          callerName
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) cb(true);
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        if (cb) cb(false);
      });
  };
}

// Reset Guest Link
export function resetGuestLink(meetingRoom, cb) {
  return (dispatch) => {
    fc.put(window.APP.CONFIGURATION.VCCAPI + 'meetingrooms/' + meetingRoom.id + '/resetGuestLink')
      .then((response) => {
        var resetGuestLinkForm = {
          ...response,
          id: meetingRoom.id,
        };
        dispatch({ type: GUEST_LINK_UPDATED, data: resetGuestLinkForm });
        var successMessage = APP.LANGUAGE.ResetGuestLink.SuccessfulMessage.replace(
          '##meetingRoomUpdate##',
          meetingRoom.name
        );
        dispatch(
          displayGlobalMessage({
            text: successMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) cb(false);
      })
      .catch((err, resp) => {
        console.error('There was an API error', err.toString());
        if (cb) cb(false);
      });
  };
}

// Manage users
export function getAvailableRolesforMeetingRoom(meetingRoomId, cb) {
  return (dispatch) => {
    let apiPath = 'meetingrooms/' + meetingRoomId + '/Roles';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPath)
      .then((data) => {
        dispatch({
          type: GOT_AVAILABLE_ROLES_FOR_MEETING_ROOM,
          data: {
            meetingRoomUsers: data,
            meetingRoomId: meetingRoomId,
          },
        });
        if (cb) cb();
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function updateMeetingRoomMemberSearch(searchTerm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_MEETING_ROOM_MEMBER_SEARCH, data: searchTerm });
  };
}

export function updateSelectedUser(userId, cb) {
  return (dispatch) => {
    dispatch({ type: UPDATE_MR_SELECTED_USER_FOR_MANAGEMENT, data: userId });
    if (cb) cb();
  };
}

export function selectRoleAddUsersForm(roleId) {
  return (dispatch) => {
    return dispatch({
      type: MR_ADD_USERS_FORM.SELECT_ROLE,
      data: roleId,
    });
  };
}

export function unSelectRoleAddUsersForm(roleId) {
  return (dispatch) => {
    return dispatch({
      type: MR_ADD_USERS_FORM.UNSELECT_ROLE,
      data: roleId,
    });
  };
}

export function updateMessageAddUsersForm(message) {
  return (dispatch) => {
    return dispatch({
      type: MR_ADD_USERS_FORM.UPDATE_MESSAGE,
      data: message,
    });
  };
}

export function clearAddUsersForm() {
  return (dispatch) => {
    return dispatch({
      type: MR_ADD_USERS_FORM.CLEAR_FORM,
    });
  };
}
// Add users
export function addUsersToMeetingRoom(meetingRoom, model, cb) {
  return (dispatch) => {
    // Update UI to show adding in progress
    dispatch({
      type: MR_ADD_USERS_FORM.ADDING_USERS_TO_MEETING_ROOM,
      data: meetingRoom.id,
    });

    // Call VCC API
    const apiParam = 'meetingrooms/' + meetingRoom.id + '/addusers';
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(model),
    })
      .then((res) => {
        let cbForGetUsers = () => {
          // show success message
          const totalUsersAdded = model.userInvites.length + model.emailInvites.length;
          const successMessage =
            totalUsersAdded > 1
              ? APP.LANGUAGE.OrganisationalUnitAddUsersModal.MultipleUserAddedSuccess.replace(
                  '##entityName##',
                  meetingRoom.name
                )
              : APP.LANGUAGE.OrganisationalUnitAddUsersModal.SingleUserAddedSuccess.replace(
                  '##entityName##',
                  meetingRoom.name
                );

          dispatch(
            displayGlobalMessage({
              text: successMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );

          // udpate redux state
          dispatch({
            type: MR_ADD_USERS_FORM.CLEAR_FORM,
          });

          dispatch({
            type: SEARCH_SELECT_USERS_FORM.CLEAR_FORM,
          });
          if (cb) cb(true);
          dispatch(showHideMeetingRoomAddUsersModal(false));
        };

        // re-fetch the meeting room users list
        dispatch(getMeetingRoomUsers(meetingRoom.id, cbForGetUsers));
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        if (cb) cb(false);
      });
  };
}
// Manage user role
export function setManageRoleForm(rolesArray) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_ROLES_FOR_SELECTED_USER_IN_MR_MANAGE_USERS_PAGE,
      data: rolesArray,
    });
  };
}
// Invite / Cancel invitation
export function resendInvitionToMeetingRoom(meetingRoom, user) {
  return (dispatch) => {
    // Call VCC API
    const apiParam = 'meetingrooms/' + meetingRoom.id + '/resendinvitation/' + user.id;
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((res) => {
        let cbForGetUsers = () => {
          // show success message
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.MeetingRoomUserActionMenu.ResendInviteSuccessMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        };

        // re-fetch the meeting room users list
        dispatch(getMeetingRoomUsers(meetingRoom.id, cbForGetUsers));
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

export function cancelInvitionToMeetingRoom(meetingRoom, user) {
  return (dispatch) => {
    // Call VCC API
    const apiParam = 'meetingrooms/' + meetingRoom.id + '/cancelinvitation/' + user.id;
    fc.put(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((res) => {
        let cbForGetUsers = () => {
          // show success message
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.MeetingRoomUserActionMenu.CancelInviteSuccessMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        };

        // re-fetch the meeting room users list
        dispatch(getMeetingRoomUsers(meetingRoom.id, cbForGetUsers));
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
      });
  };
}

// TODO - MR pagination - to check if it should replace the original method
export function getMRCurrentSearchTerm() {
  let meetingRoomReducer = window.getState().meetingRoomReducer;
  let searchTerm = meetingRoomReducer.mrSearchForm.searchString;
  searchTerm = typeof searchTerm != 'string' || searchTerm == null || searchTerm == undefined ? '' : searchTerm.trim();
  return searchTerm;
}
export function getMeetingRoomsByPage(mrSearchPayLoad, cb) {
  return (dispatch) => {
    // For implicitly load meeting rooms
    // This is also called from pubnub updates, and will pass mrSearchPayLoad as null
    if (mrSearchPayLoad == null) {
      mrSearchPayLoad = {
        searchString: getMRCurrentSearchTerm(),
        pageNo: 1,
      };
    }
    let errorCallback = (response) => {
      console.error('ERROR', response);
      dispatch({ type: ERROR_GETTING_MEETING_ROOMS_PAGINATION });
    };

    const apiPart = 'meetingrooms/meetingrooms';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiPart, { body: JSON.stringify(mrSearchPayLoad) })
      .then((data) => {
        // Data need to do checking, if there are duplicate mrs then do not need to put in the store.
        // Only store the new fetched mrs
        let passData = { ...data, pageNo: mrSearchPayLoad.pageNo };
        let res = dispatch({
          type: GOT_MEETING_ROOMS_PAGINATION,
          data: passData,
        });

        if (cb) {
          if (!!data.meetingRooms && Array.isArray(data.meetingRooms) && data.meetingRooms.length > 0) {
            // If still more MRs can be retrieved, set first argument to be true
            cb(true, true);
          }
          // else, set first argument to be false means last page reached should not increase current active page no.
          else cb(false, true);
        }
        return res;
      })
      .catch((err) => {
        if (cb) cb(false, false);
        errorCallback(err);
      });
  };
}

export function resetMRSearchForm(cb) {
  return (dispatch) => {
    dispatch({ type: RESET_MR_SEARCH_FROM });
    if (cb) cb();
  };
}

export function updateMRSearchForm(newMRSearchForm) {
  return (dispatch) => {
    dispatch({ type: UPDATE_MR_SEARCH_FROM, data: newMRSearchForm });
  };
}

export function updateCurrentActivePageNo(updateOffset, cb) {
  return (dispatch) => {
    dispatch({ type: UPDATE_CURRENT_ACTIVE_PAGENO_FOR_MRS_PAGE, data: updateOffset });
    if (cb) cb();
  };
}

export function getMeetingRoomWithSearchTerm(meetingRoomId, cb) {
  return (dispatch) => {
    let searchTerm = getMRCurrentSearchTerm();
    dispatch({ type: GET_MEETING_ROOM_DETAILS });
    fc.post(window.APP.CONFIGURATION.VCCAPI + 'meetingrooms/meetingrooms/' + meetingRoomId, {
      body: JSON.stringify(searchTerm),
    })
      .then((data) => {
        let res = dispatch({ type: GOT_MEETING_ROOM_DETAILS, data: data });

        if (cb) cb();
        return res;
      })
      .catch((err) => {
        console.error('There was an API error', err.toString());
        dispatch({ type: ERROR_GETTING_MEETING_ROOM_DETAILS });
        // If this meeting room does not exist, need to check it state.meetingrooms has it
        // If it exists in state.meetingrooms then remove it
        if (err && err.status == 404) {
          dispatch({ type: DELETED_MEETING_ROOM, data: { id: meetingRoomId } });
        }
      });
  };
}

// It is called when receiving pubnub updates "user-updated"
export function getAllMeetingRooms(mrSearchPayLoad, cb) {
  return (dispatch) => {
    let meetingRoomsNumber = window.getState().meetingRoomReducer.meetingRooms.length;
    let isOnMRListingPage = window.getState().meetingRoomReducer.isOnMRListingPage;
    let selectedMeetingRoom = window.getState().meetingRoomReducer.selectedMeetingRoom;
    if (meetingRoomsNumber > 60 && !!isOnMRListingPage) {
      // Display global message
      dispatch(
        displayGlobalMessage({
          text: APP.LANGUAGE.ViewMeetingRoom.MRNeedsToUpdateMsg,
          visible: true,
          messageType: APP.LANGUAGE.GlobalMessageTypes.Warning,
          autoHide: true,
          enableHideAndBtn: true,
          gotItButtonText: APP.LANGUAGE.ViewMeetingRoom.MRNeedsToUpdateBtn,
          btnOnclick: () => {
            dispatch(getMeetingRoomsByPage(mrSearchPayLoad, cb));
          },
        })
      );
    } else if (meetingRoomsNumber <= 60 && !!isOnMRListingPage) {
      // Get the first set of mrs
      console.log('====fetch first 60 meeting rooms');

      dispatch(getMeetingRoomsByPage(mrSearchPayLoad, cb));
    } else {
      // TODO - see if it's overhead
      // Check selected meeting room details
      console.log('====not on meeting room page so just fetch that meeting room');
      if (
        selectedMeetingRoom &&
        selectedMeetingRoom.id != null &&
        selectedMeetingRoom.id != undefined &&
        selectedMeetingRoom.id != ''
      )
        dispatch(getMeetingRoomWithSearchTerm(selectedMeetingRoom.id));
      return;
    }
  };
}

export function updateIsOnMRListingPage(isOnMrPage) {
  return (dispatch) => {
    dispatch({ type: IS_ON_MR_LISTING_PAGE, data: isOnMrPage });
  };
}

// Get meeting room authTicketId
export function createVidyoRoomAuthTicket(meetingRoomId, cb) {
  return (dispatch) => {
    const apiPart = 'meetingrooms/roomAuthTicket';
    var data = { meetingRoomId };

    fc.post(window.APP.CONFIGURATION.VCCAPI + 'meetingrooms/VidyoRoomAuthTicket', {
      body: JSON.stringify(data),
    })
      .then((data) => {
        if (cb) cb(true, data);
      })
      .catch((err, resp) => {
        cb(false);
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.ViewMeetingRoom.JoinCallError,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: false,
            apiURL: window.APP.CONFIGURATION.VCCAPI + 'meetingrooms/VidyoRoomAuthTicket',
            browserURL: window.location.href,
          })
        );
        console.error('There was an error creating Auth Ticket', err.toString());
      });
  };
}
